import React, { Component } from "react";
import { ScrollView, View, StyleSheet, Dimensions } from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";

import { translate, CurrentLocale } from "../locales/translate";
import Loading from "../components/Loading";

import DateRangePicker from "../components/DateRangePicker";

import BarChart from "../components_v2/BarChart";
import ArTheme from "../argon-ui/Theme";
let moment = require("moment-jalaali");

const SCREEN_HEIGHT = Dimensions.get("screen").height;
const SCREEN_WIDTH = Dimensions.get("screen").width;

class AreaWaterMeterScreen extends Component {
  constructor(props) {
    super(props);
    let _areaId = 0;
    let _areaUId = "";
    if (
      this.props.navigation.state.params &&
      this.props.navigation.state.params.areaId
    ) {
      _areaId = this.props.navigation.state.params.areaId;
    }
    if (
      this.props.navigation.state.params &&
      this.props.navigation.state.params.areaUId
    ) {
      _areaUId = this.props.navigation.state.params.areaUId;
    }

    this.state = {
      isLoading: true,
      serverUrl: undefined,
      accessToken: undefined,
      areaId: _areaId,
      areaUId: _areaUId,
      areaName: "",
      consumptionData: [],
      consumptionTotalUsage: "",
      showDatePicker: false,
      dateFrom: null,
      dateTo: null,
      duration: "today",
      customDuration: "daily",
      locale: CurrentLocale,
      monthlyStartYear: undefined,
      monthlyStartMonth: 1,
      monthlyEndYear: undefined,
      monthlyEndMonth: 1,
    };

    this.consumptionChartRef = undefined;

    this.colorSet = [
      "#36a2eb",
      "#ff6384",
      "#cc65fe",
      "#ffce56",
      "#5cb85c",
      "#f0ad4e",
      "#0275d8",
      "#d9534f",
    ];
    // for (var i in ArTheme.COLORS) {
    //   this.colorSet.push(ArTheme.COLORS[i]);
    // }
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.AreaWaterMeter"),
  });
  componentDidMount() {
    let { currentServer, serverUrl } = this.props.appReducer;

    if (!serverUrl.endsWith("/")) {
      serverUrl = serverUrl + "/";
    }
    this.setState(
      {
        serverUrl,
        accessToken: currentServer.accessToken,
      },
      () => {
        this.getAllReports();
      }
    );

    if (this.state.areaId) {
      let { areas } = this.props.reducer;
      for (var i in areas) {
        let area = areas[i];
        if (area.areaId == this.state.areaId) {
          this.setState({ areaName: area.areaName });
          break;
        }
      }
    }
  }

  getAllReports = () => {
    this.getConsumptionReport();
  };

  getConsumptionReport = () => {
    let { serverUrl, accessToken } = this.state;
    this.setState({ isLoading: true, showDatePicker: false });
    if (serverUrl) {
      // filters
      var filters = [];

      if (this.state.dateFrom)
        filters.push(`from=${new Date(this.state.dateFrom).toDateString()}`);

      if (this.state.dateTo)
        filters.push(`to=${new Date(this.state.dateTo).toDateString()}`);

      if (this.state.duration) filters.push(`duration=${this.state.duration}`);

      if (this.state.customDuration)
        filters.push(`customDuration=${this.state.customDuration}`);

      filters.push(`locale=${this.state.locale || ""}`);

      if (this.state.areaUId) filters.push(`uId=${this.state.areaUId}`);
      // end filters

      var url = `${serverUrl}WaterConsumption/AreaWaterMeter/${
        this.state.areaId
      }?${filters.join("&")}`;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        // body: JSON.stringify({
        // }),
      })
        .then((res) => {
          this.setState({
            isLoading: false,
          });
          return res.json();
        })
        .then((resj) => {
          if (resj.areaId && resj.logs != null) {
            this.setState({
              consumptionData: resj.logs,
              consumptionTotalUsage: `${resj.totalUsage} ${resj.unit}`,
              isLoading: false,
            });
          } else {
            this.setState({
              serverAuthErrors: resj.errors,
              isLoading: false,
            });
          }
        })
        .catch((err) => {
          {
            console.log(err);
            this.setState({ isLoading: false });
          }
        });
    }
  };

  toggleDatePicker = () => {
    this.setState({ showDatePicker: !this.state.showDatePicker });
  };

  handleOnDatePick = (tick, p) => {
    let f = this.state.dateFrom != null;
    let t = this.state.dateTo != null;
    if (p == "START_DATE") {
      //(f && t) || (!f && !t) both are selected or both are empty
      // set from date and clear toDate
      this.setState({ dateFrom: tick, dateTo: null });
    } else {
      this.setState({ dateTo: tick });
    }
  };

  render() {
    if (this.state.isLoading)
      return <Loading message={translate("app.pleaseWaite")} />;
    else
      return (
        <ScrollView style={{}}>
          <View style={{ alignItems: "center" }}>
            <Text
              style={{ fontSize: 18, fontWeight: "bold", paddingVertical: 10 }}
            >
              {this.state.areaName}
            </Text>
            <DateRangePicker
              duration={this.state.duration}
              customDurationType={this.state.customDuration}
              monthlyStartYear={this.state.monthlyStartYear}
              monthlyStartMonth={this.state.monthlyStartMonth}
              monthlyEndYear={this.state.monthlyEndYear}
              monthlyEndMonth={this.state.monthlyEndMonth}
              from={this.state.dateFrom}
              to={this.state.dateTo}
              onDurationChange={(duration) =>
                this.setState({ duration }, () => {
                  this.getConsumptionReport();
                })
              }
              onRefresh={this.getConsumptionReport}
              onDateChange={this.handleOnDatePick}
              onCustomDurationTypeChange={(type) =>
                this.setState({ customDuration: type }, () => {
                  if (type == "monthly") {
                    var jY = Number(
                      moment(new Date().toString()).format("jYYYY")
                    );
                    var jM =
                      Number(moment(new Date().toString()).format("jM")) - 1;

                    var dateFrom = moment
                      .utc()
                      .jYear(jY)
                      .jMonth(0)
                      .jDate(1)
                      .toDate();
                    var dateTo = moment
                      .utc()
                      .jYear(jY)
                      .jMonth(jM)
                      .jDate(1)
                      .toDate();

                    console.log(dateFrom, dateTo);
                    this.setState({ dateFrom, dateTo }, () => {
                      this.getConsumptionReport();
                    });
                  } else {
                    this.getConsumptionReport();
                  }
                })
              }
              onMonthlyDurationChange={(data) => {
                let { endMonth, endYear, startMonth, startYear } = data;
                this.setState(
                  {
                    monthlyStartYear: startYear,
                    monthlyStartMonth: startMonth,
                    monthlyEndYear: endYear,
                    monthlyEndMonth: endMonth,
                    dateFrom: moment
                      .utc()
                      .jYear(startYear)
                      .jMonth(startMonth - 1)
                      .jDate(1)
                      .toDate(),
                    dateTo: moment
                      .utc()
                      .jYear(endYear)
                      .jMonth(endMonth - 1)
                      .jDate(1)
                      .toDate(),
                  },
                  () => {
                    this.getConsumptionReport();
                  }
                );
              }}
            />
            {this.state.consumptionData &&
              this.state.consumptionData.length > 0 && (
                <View style={styles.chartWrapper}>
                  <Text style={styles.chartTitle}>
                    {translate("deviceLog.waterConsumption")}
                  </Text>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Text
                      style={{
                        paddingHorizontal: 10,
                        // borderWidth: 1,
                        // borderColor: "red",
                        //flex: 1,
                      }}
                    >
                      {translate("deviceLog.totalUsage")}:
                    </Text>
                    <Text style={styles.totalUsageText}>
                      {this.state.consumptionTotalUsage}
                    </Text>
                  </View>
                  <BarChart
                    data={this.state.consumptionData}
                    backgroundColor="#163BA1"
                    backgroundGradientFrom="#164CDD"
                    backgroundGradientTo="#678CDD"
                  />
                </View>
              )}
          </View>
        </ScrollView>
      );
  }
}

const styles = StyleSheet.create({
  chartWrapper: {
    marginVertical: 15,
    padding: 10,
    borderRadius: 10,
    backgroundColor: ArTheme.COLORS.BLOCK,
    flex: 1,
    width: "100%",
  },
  chartTitle: {
    fontSize: 18,
    padding: 10,
    fontWeight: "bold",
  },
  totalUsageText: {
    fontWeight: "bold",
    fontSize: 36,
    textAlign: "left",
    writingDirection: "ltr",
    color: ArTheme.COLORS.MUTED,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.AreaReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AreaWaterMeterScreen);
